import React from "react";
import "./SoftwareDevelopmentPage.css";
import BannerImage from "../../../assets/other_image/sofware_develoment.jpg";
import SoftwareDevelopmentOverview from "./SoftwareDevelopmentOverview";
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../SolutionBanner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";

const SoftwareDevelopmentPage = () => {
  return (
    <section className="softwareDevelopmentprocess">
      <Banner
        image={BannerImage} // Pass the image for this page
        heading="Software Development" // Pass the heading text for this page
      />
        <FloatingContactUs />
      <SoftwareDevelopmentOverview />

      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="solution-page-heading">Unlock the Power :</h4>
          <h5 className="solution-subheading">
            Discover the Transformative Benefits of Software Development with NexTech!
          </h5>
          <p className="plmimplementationparagraph">
            Well-defined methodologies and our vast experience lead us to design
            our unique delivery model which enhances business performance and
            ensures quality product delivery in timely manner. This model has
            helped our customers by :
          </p>
          <ul className="custom-bullets">
            <li>Reducing cost.</li>
            <li>Increasing productivity. </li>
            <li>Improving quality and consistency.</li>
            <li>Ensuring predictability and timeliness.</li>
            <li>Reducing risk.</li>
            <li>Improving cross-group coordination. </li>
            <li>Improving skills. </li>
            <li>
              Increasing the number of opportunities for the re-use of
              technologies and processes.{" "}
            </li>
          </ul>
        </div>
      </section>

      <section>
        <div className="solutions container">
          <h4 className="solution-page-heading">Our Solutions</h4>
          <p className="plmimplementationparagraph">Software connector: These are required for data smoothening and transfer from one system to other system which is critical and important. </p>
          <ul className="custom-bullets">
            <li>Legacy tools integration </li>
            <li>Data migration </li>
            <li>Data cleanup </li>
            <li>Assembly line balancing </li>
            <li>Design Automation </li>
          </ul>
        </div>
      </section>

      <section style={{ background: "#f5f7fa" }}>
        <div className="why-nextech container">
          <h4 className="solution-page-heading">Why NexTech?</h4>
          <h5 className="solution-subheading">
            For Custom Software Development
          </h5>
          <ul className="custom-bullets">
            <li>
            Well-defined methodologies and vast experience ensure adherence to international standards, guaranteeing efficient and robust software development. 
            </li>
            <li>
            Unique delivery model enhances business performance, ensuring timely delivery of high-quality products. 
            </li>
            <li>
            Expertise in reducing costs, increasing productivity, and improving quality and consistency through optimized processes. 
            </li>
            <li>
            Proven track record in risk mitigation, predictability, and timely project completion. 
            </li>
            <li>
            Specialized offerings including software connectors for critical data integration needs like legacy tools integration, data migration, cleanup, assembly line balancing, and design automation. 
            </li>
          </ul>
        </div>
      </section>

      <Letsgetintouch />
    </section>
  );
};

export default SoftwareDevelopmentPage;
